import React from 'react';
import routerConfig from './routerConfig';

import { useRoutes } from 'react-router-dom';

import FilterContext from '../context/filterContext/filterContext';
import DocsContext from '../context/docsContext/docsContext';
import BoardsContext from '../context/boardsContext/boardsContext';

interface IRoutes{
  setShowAgreement?: (e?: any) => void;
  authorized?: boolean;
  authenticated?: boolean;
  showAgreement?: boolean;
}

const Routes: React.FC<IRoutes> = ({setShowAgreement, authorized, authenticated, showAgreement}) => {
  let element = useRoutes(routerConfig(setShowAgreement, authorized, authenticated, showAgreement));

  return (
    <FilterContext>
      <DocsContext>
        <BoardsContext>
          {element}
        </BoardsContext>
      </DocsContext>
    </FilterContext>
  );
};

export default Routes;
